import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { CAMPAIGN, getNextDraw } from "@/config/campaign";
import { EASE } from "@/components/Reveal";

// Linker Inhaltsblock der Hero-Sektion (das Formular rendert die LandingPage daneben).
export const Hero = () => {
  const nxt = getNextDraw();
  return (
    <div>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: EASE }}
        className="text-xs font-bold uppercase tracking-[0.3em] text-gold-dark"
        data-testid="hero-eyebrow"
      >
        {CAMPAIGN.eyebrow}
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.08, ease: EASE }}
        className="mt-2 text-sm font-medium text-mutedlight"
        data-testid="hero-trust-line"
      >
        {CAMPAIGN.trustLine}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
        className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl"
        data-testid="hero-headline"
      >
        Gewinne <span className="text-gold-dark">7 Jahre</span> Steuererklärung gratis
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25, ease: EASE }}
        className="mt-3 font-display text-xl font-bold text-ink sm:text-2xl"
        data-testid="hero-subheadline"
      >
        + 25 weitere Gewinner
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.33, ease: EASE }}
        className="mt-1.5 text-sm text-mutedlight sm:text-base"
        data-testid="hero-prize-line"
      >
        20× Steuererklärung 2027 gratis · 5× CHF 100 Cash
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.42, ease: EASE }}
        className="mt-6 rounded-[18px] border border-gold/40 bg-gold-dim p-5"
        data-testid="hero-bonus-block"
      >
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold-dark">
          <Gift className="h-4 w-4" strokeWidth={2} /> Garantierter Sofortbonus
        </p>
        <p className="mt-2 text-sm font-semibold text-ink">
          Jeder Teilnehmer erhält direkt das {CAMPAIGN.bonusName}.
        </p>
        <p className="mt-1 text-xs text-mutedlight">23 Prüfpunkte · Unterlagenliste · 5-Minuten-Check</p>
      </motion.div>
      {nxt && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.52 }}
          className="mt-4 text-sm font-medium text-ink"
          data-testid="hero-next-draw"
        >
          Nächste Ziehung: <span className="font-bold text-gold-dark">{nxt.label}</span>
        </motion.p>
      )}
    </div>
  );
};
